import { render, staticRenderFns } from "./letterPanel.vue?vue&type=template&id=7b578a1c&scoped=true&"
import script from "./letterPanel.vue?vue&type=script&lang=js&"
export * from "./letterPanel.vue?vue&type=script&lang=js&"
import style0 from "./letterPanel.vue?vue&type=style&index=0&id=7b578a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b578a1c",
  null
  
)

export default component.exports